import { useQuery } from '@tanstack/react-query'
import {
  type PostTaskSchedulesRequestBody,
  TasksApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeys } from './queryKeys'

/**
 * 試算（POST /taskSchedules/simulate）。保存せずに「この設定でできる先頭 6 件のタスク」を計算して返す。
 *
 * 役割はタスクの試算で、検証の代わりではない（検証は保存側の 400 が担う）。
 * 開始日の計算はフロントに置かず、この結果を描くだけにする（2026-09-16 決定）。
 * 「試算する」ボタンで呼ぶので、呼び出し側は押した時点の body を渡し、押す前は null を渡す。
 * 受理できない body には 200 で accepted=false と欄ごとの理由が返る（フォームの判定を抜けた値の保険）。
 */
export const useQueryTaskScheduleSimulation = (
  body: PostTaskSchedulesRequestBody | null,
) =>
  useQuery({
    queryKey: queryKeys.simulation(body),
    queryFn: () => {
      if (body === null) throw new Error('simulation body is not set')
      return baseClient
        .getApi(TasksApi)
        .postTaskSchedulesSimulate({ postTaskSchedulesRequestBody: body })
    },
    enabled: body !== null,
    staleTime: 60 * 1000,
    retry: false,
  })
